import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import { Authenticated } from "./Authenticated";
import UserContext from "./UserContext";
import { Form, FormControl, Button } from "react-bootstrap"
import { ApiHelper, LoginRequestInterface, LoginResponseInterface, UserHelper, ToastHelper } from "./helpers";

export const Login: React.FC = () => {
  const [cookies, setCookie] = useCookies();
  const location = useLocation();
  const context = React.useContext(UserContext);

  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  let search = new URLSearchParams(location.search);
  let jwt = search.get("jwt") || cookies.jwt;
  let guid = search.get("guid");
  if (!jwt) jwt = "";
  if (!guid) guid = "";

  const init = () => {
    if (guid) login({ resetGuid: guid });
    else if (jwt) { login({ jwt: jwt }); }
  };


  React.useEffect(init, []); //eslint-disable-line

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    switch (e.currentTarget.id) {
      case "email": setEmail(e.currentTarget.value); break;
      case "password": setPassword(e.currentTarget.value); break;
    }
  }

  const login = async (req: LoginRequestInterface) => {
    setIsSubmitting(true);
    const resp: LoginResponseInterface = await ApiHelper.postAnonymous("/users/login", req);
    if (!resp.user) {
      if (req.email) {
        if (resp.errors?.length > 0) {
          resp.errors.forEach(error => ToastHelper.error(error));
        } else {
          ToastHelper.error("Sorry, the admin is currently down for maintenance. Please check back in 30 minutes.");
        }
      }
      else window.location.href = "/logout";
    }
    else if (resp.departments.length === 0) {
      ToastHelper.error("User does not have access to any accounts.");
    }
    else {
      UserHelper.user = resp.user;
      UserHelper.departments = resp.departments;
      UserHelper.currentDepartment = resp.departments[0];
      //UserHelper.departmentChanged = true;
      ApiHelper.setDefaultPermissions(UserHelper.currentDepartment.jwt);
      ApiHelper.isAuthenticated = true;
      context.setUserName(UserHelper.currentDepartment.id.toString());
      setCookie("jwt", UserHelper.currentDepartment.jwt, { path: "/" });
    }
    setIsSubmitting(false);
  }

  const handleSubmit = (e: React.MouseEvent) => {
    let errors: string[] = [];
    if (email.length === 0) errors.push("Please enter an email address.");
    if (password.length === 0) errors.push("Please enter a password.");

    if (errors.length > 0) {
      errors.forEach(error => ToastHelper.error(error));
    } else {
      login({ email: email, password: password });
    }
  }

  const getLoginBox = () => {
    return (
      <div id="loginBox" data-testid="login-box">
        <h2>Please sign in</h2>

        <Form.Group className="mb-3">
          <FormControl type="text" aria-label="email" id="email" data-testid="email-input" value={email} onChange={handleChange} placeholder="Email address" />
        </Form.Group>
        <Form.Group className="mb-3">
          <FormControl type="password" aria-label="email" id="password" data-testid="password-input" value={password} onChange={handleChange} placeholder="Password" />
        </Form.Group>
        <Button type="submit" id="signInButton" data-testid="sign-in-button" size="lg" variant="primary" className="d-grid" disabled={isSubmitting} style={{ width: "100%" }} onClick={handleSubmit}>
          {(isSubmitting) ? "Please wait..." : "Sign in"}
        </Button>


        <br />
        <div className="text-right">
          <a href="https://signpresenter.com/#signUp">Register</a> | <Link to="/forgot">Forgot Password</Link>
        </div>
      </div>
    );
  }




  if (context.userName === "" || !ApiHelper.isAuthenticated) {
    return (<div className="smallCenterBlock">{getLoginBox()}</div>);
  } else {
    return <Authenticated />;
  }
};